<template>
  <FlotoFixedView>
    <MRow class="h-100">
      <MCol :size="12" class="flex flex-col h-100">
        <MRow :gutter="0" class="px-4">
          <MCol :sm="3" :size="12">
            <FlotoPageHeader
              :back-link="backRoute"
              :title="$tc('active_directory_self_service')"
            >
            </FlotoPageHeader>
          </MCol>
          <FlotoScrollView>
            <FlotoForm @submit="validateUser">
              <MRow :gutter="0" class="px-4">
                <MCol :sm="3" :size="12">
                  <FlotoFormItem
                    v-model="email"
                    :validation-label="$tc('email_or_logon')"
                    :placeholder="$tc('email_or_logon')"
                    rules="required"
                  >
                    <template v-slot:prefix>
                      <MIcon name="envelope" />
                    </template>
                  </FlotoFormItem>
                </MCol>
              </MRow>
              <template v-slot:submit>
                <MRow :gutter="0" class="px-4 text-right">
                  <MCol :sm="3" :size="12">
                    <MButton
                      class="mr-2"
                      outline
                      type="submit"
                      @click="selfServiceType = 'reset_password'"
                    >
                      {{ $tc('reset_password') }}
                    </MButton>
                    <MButton
                      type="submit"
                      outline
                      @click="selfServiceType = 'unlock_account'"
                    >
                      {{ $tc('unlock_account') }}
                    </MButton>
                  </MCol>
                </MRow>
              </template>
            </FlotoForm>
          </FlotoScrollView>
        </MRow>
      </MCol>
    </MRow>
  </FlotoFixedView>
</template>

<script>
import { validateUserApi } from '../support-portal-api'
export default {
  name: 'SelfService',
  data() {
    return {
      email: '',
      selfServiceType: '',
    }
  },
  computed: {
    backRoute() {
      return this.$currentModule.getRoute('')
    },
  },
  methods: {
    validateUser() {
      validateUserApi({
        email: this.email,
        selfServiceType: this.selfServiceType,
      }).then((data) => {
        this.$router.replace(
          this.$currentModule.getRoute('question-answer-portal', {
            params: {
              email: data.email,
              configuredQuestions: data.configuredQuestions,
              selfServiceType: data.selfServiceType,
            },
          })
        )
      })
    },
  },
}
</script>
